import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { IconAirplane } from '@wds/icons';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Textarea } from '@wds/textarea';
const COPY = {
  SendBtnTitle: {
    id: 'prompt-input.PromptInput.SendBtnTitle',
    defaultMessage: 'Send prompt',
    description: '[Type: label][Vis: low] - Alt text for send button (which visually only contains an icon)'
  }
};
const useStyles = createUseStyles(theme => ({
  container: {
    width: '100%'
  }
}));
/**
 * Prompt input for conversational AI interfaces.
 */
const PromptInput = ({
  disabled,
  id,
  loading,
  onPrompt,
  placeholder
}) => {
  const [prompt, setPrompt] = useState('');
  const sendPrompt = () => {
    onPrompt === null || onPrompt === void 0 ? void 0 : onPrompt(prompt);
    setPrompt('');
  };
  const {
    container
  } = useStyles();
  return _jsx(Box, {
    className: container,
    children: _jsxs(InputGroup, {
      stretched: true,
      children: [_jsx(Textarea, {
        id: id !== null && id !== void 0 ? id : 'send-prompt-btn',
        placeholder: placeholder,
        value: prompt,
        onChange: e => {
          setPrompt(e.target.value);
        },
        onKeyDown: e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            sendPrompt();
          }
        },
        resizable: false
      }), _jsx(InputGroupAddon, {
        children: _jsx(Button, {
          color: "success",
          label: t(COPY.SendBtnTitle),
          onClick: sendPrompt,
          disabled: disabled || !prompt,
          loading: loading,
          children: _jsx(IconAirplane, {
            title: ""
          })
        })
      })]
    })
  });
};
export default PromptInput;